module.exports = __webpack_public_path__ + "static/media/wechat-qr-new.3966035f.png";